module.exports = __webpack_public_path__ + "stockLibrary/service_5-30d8a0049c41050a79272a523bdfcb87.png";